// extracted by mini-css-extract-plugin
module.exports = {"UserAvatar":"styles_UserAvatar__2z0PG","EditLabel":"styles_EditLabel__3ccAB"};